import { render, staticRenderFns } from "./OrderSelectShipper.vue?vue&type=template&id=8d812560&"
import script from "./OrderSelectShipper.vue?vue&type=script&lang=js&"
export * from "./OrderSelectShipper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports